export default __webpack_public_path__ + "static/media/29.8fcc298b.svg";